// components/Services.jsx — Responsive service cards grid + mobile swiper

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { SectionWrapper, SectionTitle, Card } from "./UI";

function ServiceCard({ svc, dark, isEs }) {
  const title       = isEs ? (svc.titleEs       || svc.title)       : svc.title;
  const description = isEs ? (svc.descriptionEs || svc.description) : svc.description;
  const subServices = isEs ? (svc.subServicesEs || svc.subServices) : svc.subServices;

  return (
    <Card dark={dark} className="p-6 flex flex-col h-full">
      <div className="mb-5">
        {svc.imageUrl ? (
          <img src={svc.imageUrl} alt={title} className="w-12 h-12 rounded-xl object-cover" />
        ) : (
          <div className={`w-12 h-12 rounded-xl flex items-center justify-center text-2xl ${dark ? "bg-white/5" : "bg-[#E2E8F0]/70"}`}>
            {svc.icon || "🔧"}
          </div>
        )}
      </div>
      <h3 className="text-base font-bold mb-2">{title}</h3>
      <p className={`text-sm leading-relaxed mb-5 flex-1 ${dark ? "text-white/55" : "text-[#0F172A]/55"}`}>
        {description}
      </p>
      <ul className="space-y-1.5">
        {subServices?.map((sub, i) => (
          <li key={i} className={`text-xs flex items-start gap-2 ${dark ? "text-white/40" : "text-[#0F172A]/40"}`}>
            <span className="text-[#A3E635] mt-0.5 shrink-0 font-bold">✓</span>
            {sub}
          </li>
        ))}
      </ul>
    </Card>
  );
}

export default function Services({ content, t, dark, lang, mobileSwiper = true }) {
  const isEs = lang === "es";

  return (
    <SectionWrapper id="services" dark={dark} bg="default">
      <SectionTitle title={t.services.sectionTitle} subtitle={t.services.sectionSubtitle} dark={dark} />

      {/* Desktop: always grid */}
      <div className="hidden sm:grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {content.map((svc) => (
          <ServiceCard key={svc.id} svc={svc} dark={dark} isEs={isEs} />
        ))}
      </div>

      {/* Mobile: swiper or vertical list */}
      {mobileSwiper ? (
        <div className="sm:hidden -mx-4 overflow-x-hidden">
          <style>{`
            .services-swiper .swiper-pagination-bullet { background: #A3E635; opacity: 0.4; }
            .services-swiper .swiper-pagination-bullet-active { background: #A3E635; opacity: 1; }
          `}</style>
          <Swiper
            className="services-swiper pb-10"
            modules={[Pagination]}
            pagination={{ clickable: true }}
            spaceBetween={12}
            slidesPerView={1.2}
            slidesOffsetBefore={16}
            slidesOffsetAfter={16}
          >
            {content.map((svc) => (
              <SwiperSlide key={svc.id} className="!h-auto pb-2">
                <ServiceCard svc={svc} dark={dark} isEs={isEs} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      ) : (
        <div className="sm:hidden grid grid-cols-1 gap-5">
          {content.map((svc) => (
            <ServiceCard key={svc.id} svc={svc} dark={dark} isEs={isEs} />
          ))}
        </div>
      )}
    </SectionWrapper>
  );
}
